import MoneyInput from 'components/MoneyInput';
import React from 'react';
import { useRateCalculations } from '../hooks/useRateCalculations';
import type { ClassificationSpecificInheritedSettings } from '../../types/inheritedSettings.types';
import { DisplayHelpers } from 'utils/helpers';
import { getInheritedSettings } from '../PositionRateSettingsForm.utils';
import { useFormContext } from 'react-hook-form';

type Props = {
  source: string;
  inheritedSettings: ClassificationSpecificInheritedSettings;
};

export const ProfessionalRateInput = ({ source, inheritedSettings }: Props) => {
  const { handlers } = useRateCalculations({ source, inheritedSettings });
  const { watch } = useFormContext();

  const mergedSettings = getInheritedSettings({ source, inheritedSettings, watch });

  const { pro_rate_cents } = mergedSettings;

  return (
    <MoneyInput
      source={`${source}.pro_rate_cents`}
      label="Professional Rate"
      onChange={(event) => handlers.handleProfessionalRateChange(event.target.value)}
      helperText={`Adjusted rate: ${DisplayHelpers.money(pro_rate_cents - 10)}`}
    />
  );
};
